/* global bootstrap */

// Utility function to get or create a modal instance
export const getModalInstance = (modalId) => {
  // Handle both '#modal-id' and 'modal-id' formats
  const selector = modalId.startsWith('#') ? modalId : `#${modalId}`;
  const element = document.querySelector(selector);
  if (!element) {
    return null;
  }
  return bootstrap.Modal.getInstance(element) || new bootstrap.Modal(element);
};

// Helper function to safely show a modal
export const showModal = (modalId) => {
  const modal = getModalInstance(modalId);
  if (modal) {
    modal.show();
  }
};

// Helper function to safely hide a modal
export const hideModal = (modalId) => {
  const modal = getModalInstance(modalId);
  if (modal) {
    modal.hide();
  }
};

// Helper function to hide multiple modals
export const hideModals = (modalIds) => {
  modalIds.forEach(hideModal);
};

// Check if user is from US and return modal show function
export const showCalendarModalForUS = (ipInfo) => {
  if (ipInfo && ipInfo.country === 'United States') {
    return () => showModal('primary-demo-form-modal--hsCalendar');
  }
  return null;
};